export const HAPTIC_TAP = 10;

export const vibrate = (pattern = HAPTIC_TAP) => {
  if (typeof navigator !== "undefined" && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};
